var Vehicle = /** @class */ (function () {
    function Vehicle(props) {
        Object.assign(this, props);
    }
    return Vehicle;
}());
export default Vehicle;
export var typeVehicle = {
    quad: 'quad',
    buggy: 'buggy',
    bus: 'bus',
    van: 'van'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Vehicles/Model.ts
// module id = 745
// module chunks = 0